import { render } from "./GuessScreen.vue?vue&type=template&id=16f0a591"
import script from "./GuessScreen.vue?vue&type=script&lang=js"
export * from "./GuessScreen.vue?vue&type=script&lang=js"

import exportComponent from "/Users/peterdevos/Sites/multiple_choice_aethon/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__